import React from "react";
import logo from "./logo.svg";
import "./App.css";
import GlobalStyles from "./Styles/global";
import { EntidadeProvider } from "./Hooks/EntidadeHook";
import { Rotas } from "./Routes/index.routes";
import { UsuarioProvider } from "./Hooks/UsuarioHook";
import { IssqnProvider } from "./Storage/issqn";
import { UsuarioPrefeituraProvider } from "./Hooks/UsuarioPrefeituraHook";
import { EmpresaProvider } from "./Storage/empresa";
import { SeletorProvider } from "./Storage/seletor";
import { UsuarioNaoEmiteNotaProvider } from "./Hooks/UsuarioNaoEmiteNotaHook";
function App() {
  return (
    <EntidadeProvider>
      <UsuarioProvider>
        <UsuarioNaoEmiteNotaProvider>
          <UsuarioPrefeituraProvider>
            <EmpresaProvider>
              <SeletorProvider>
                <IssqnProvider>
                  <div
                    className="App"
                    style={{
                      display: "flex",
                      flexFlow: "column",
                      justifyContent: "space-around",
                    }}
                  >
                    <GlobalStyles />
                    <Rotas />
                  </div>
                </IssqnProvider>
              </SeletorProvider>
            </EmpresaProvider>
          </UsuarioPrefeituraProvider>
        </UsuarioNaoEmiteNotaProvider>
      </UsuarioProvider>
    </EntidadeProvider>
  );
}

export default App;
